import { useEffect, useLayoutEffect, useRef } from 'react'

import { type ClickawaySubscriberType, subscribeClickaway } from '@/utils/clickawayUtil'

type Props = ClickawaySubscriberType

export const useClickaway = ({ ignore, onClickAway }: Props) => {
  const subscriberRef = useRef<ClickawaySubscriberType>({ ignore, onClickAway })

  useLayoutEffect(() => {
    subscriberRef.current.ignore = ignore
    subscriberRef.current.onClickAway = onClickAway
  }, [ignore, onClickAway])

  useEffect(() => subscribeClickaway(subscriberRef.current), [])
}
